import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon } from '@codex/icons';
import { formatPrice } from '@codex/helpers';
import AddToBasketButtonWithAjaxCall from '../../../AddToBasket/AddToBasketButtonWithAjaxCall';

const BottomWrapperDiv = styled.div`
  width: 100%;
  max-width: 256px;
  
  button {
    font-family: Helvetica;
  }
  
  @media ${(props) => props.theme.breakpoints.tablet} {
    max-width: 204px;
  }
  
  @media ${(props) => props.theme.breakpoints.mobile} {
    max-width: 128px;
  }
`;

const PriceBlock = styled.div`
  width: 100%;
  max-width: 256px;
  font-family: Helvetica;
  font-size: 30px;
  font-weight: bold;
  color: #333333;
  text-align: center;
  padding: 5px 0px 5px 0px;
  
  @media ${(props) => props.theme.breakpoints.mobile} {
    font-size: 22px;
    padding: 4px 0px 5px 0px;
  }
`;

const StyledIcon = styled(Icon)`
  width: 30px;
  height: 26px;
  margin: -13px 10px -5px 0;
  ${(props) => props.icon === 'Spinner' && `
    height: 25px;
    width: 25px;
    margin: -9px 15px -5px 0;
  `}
  @media ${(props) => props.theme.breakpoints.mobile} {
    display: none;
    ${(props) => props.icon === 'Spinner' && `
      display: inline-block;
      margin: -9px 0 -5px 0;
    `}
  }
`;

const StyledLabel = styled.span`
  ${(props) => props.isLoading && `
    display: inline-block;
    @media ${props.theme.breakpoints.mobile} {
      display: none;
    }
  `}
`;

const CompareCheckbox = styled.div`
  margin-top: 18px;
  @media ${(props) => props.theme.breakpoints.mobile} {
    display: none;
  }
`;

const WrapperDiv = styled.div`
  margin-bottom: 20px;
  
  @media ${(props) => props.theme.breakpoints.tablet} {
    margin-bottom: 15px;
  }
  
  @media ${(props) => props.theme.breakpoints.mobile} {
    margin-bottom: 15px;
  }
`;

const AddToBasketButtonWrapper = styled.div`
  margin-top: 0px;

  @media (max-width: 1239px) { 
    margin-top: 76px;
  }
  
  @media (max-width: 1024px) { 
    margin-top: 0px;
  }  
`;

const StyledLine = styled.hr`
  border-top: 1px solid #d3d3d3;
  width: 100%;
  max-width: 254px;
  margin: 0px;
    
  @media ${(props) => props.theme.breakpoints.tablet} {
    max-width: 218px;
  }

  @media ${(props) => props.theme.breakpoints.mobile} {
    max-width: 118px;
    margin: auto;
  }
`;

const BottomWrapper = ({
  productId,
  productPrice,
  productCurrency,
  buttonText,
  buttonOnClick,
  psaVariant
}) => (
  <BottomWrapperDiv>
    <WrapperDiv>
      <StyledLine />
      <PriceBlock>
        {formatPrice(productPrice, true, productCurrency)}
      </PriceBlock>
      <StyledLine />
    </WrapperDiv>
    <AddToBasketButtonWrapper>
      <AddToBasketButtonWithAjaxCall
        fupid={productId}
        quantity={1}
        full={false}
        beforeAddingToBasket={buttonOnClick}
        psaVariant={psaVariant}
        buttonPlacementID={'tradeup'}
        render={({ isLoading }) => (
          <>
            {isLoading ? (
              <StyledIcon icon={'Spinner'} spin />
            ) : (
              <StyledIcon icon={'AddToBasket'} />
            )}
            <StyledLabel isLoading={isLoading}>
              {buttonText}
            </StyledLabel>
          </>
        )}
      />
    </AddToBasketButtonWrapper>

    <CompareCheckbox
      data-component={'compare-checkbox'}
      data-productid={productId}
    />
  </BottomWrapperDiv>
);

BottomWrapper.propTypes = {
  productId: PropTypes.string.isRequired,
  productPrice: PropTypes.number.isRequired,
  productCurrency: PropTypes.string,
  buttonText: PropTypes.string.isRequired,
  buttonOnClick: PropTypes.func,
  psaVariant: PropTypes.string.isRequired
};

BottomWrapper.defaultProps = {
  productCurrency: 'GBP',
  buttonOnClick: () => {}
};

export default BottomWrapper;
